import UpdateProfile from './UpdateProfile';

export default UpdateProfile;
